import React from 'react';

import RiskProfileLoader from '../risk_profile_loader';

import { getText } from '../../../helpers';

import '../risk_profile_table.css';

const SixBySixRiskProfileTable = (props) => {
  const { profile, loading } = props;
  const { profiles=[], header={} } = profile;
  const { likelihood_header, consequence_header, rating_headers  } = header;

  return (
    <div className="risk-profile-table">
      {
        loading && <RiskProfileLoader/>
      }
      <table className="six-by-six-risk-profile-table">
        <thead>
          <tr>
            <th rowSpan="2"></th>
            <th rowSpan="2" className="likelihood-header">{getText(likelihood_header)}</th>
            <th colSpan="6" className="consequence-header">{getText(consequence_header)}</th>
          </tr>
          <tr>
            {
              rating_headers && rating_headers.map((header, i) => {
                return <th key={i} className="rating-header">{getText(header)}</th>
              })
            }
          </tr>
        </thead>
        <tbody>
        {
          profiles && profiles.map((likelihood, i)=>{
            var row_index = i + 1
            const { likelihood_level, risk_ratings } = likelihood;
            return (
              <tr key={row_index}>
                { row_index === 1 && <td rowSpan="6" className="likelihood-header upright">{getText(likelihood_header)}</td> }
                <td className="likelihood-cell">{getText(likelihood_level)}</td>
                { risk_ratings.map((rating, j)=>{
                  var col_index = j + 1;
                  const { risk_level, risk_rating, class: className, current_rating_label, current_rating_count, final_rating_label, final_rating_count } = rating;
                  return (
                    <td key={row_index + "-" + col_index} className={ "ratings " + className }>
                      <div className="rating"><span>{getText(risk_level)}</span><span> ({risk_rating})</span></div>
                      <div className="risk-count-div">
                        <div className="risk-label">{getText(current_rating_label)}: </div>
                        <div><span className="risk-count">{current_rating_count}</span></div>
                      </div>
                      <div className="risk-count-div">
                        <div className="risk-label">{getText(final_rating_label)}: </div>
                        <div><span className="risk-count">{final_rating_count}</span></div>
                      </div>
                    </td>
                  )
                })
                }
              </tr>
            )
          })
        }
        </tbody>
      </table>
    </div>
  )
}

export default SixBySixRiskProfileTable;



// WEBPACK FOOTER //
// ./src/views/risk_profile_tables/teck/six_by_six_risk_profile_table.js